import React, { useState, useEffect } from 'react';
import { galleryImages as defaultGallery, recentWorkImages as defaultRecentWork } from '../mockData';
import BeforeAfterSlider from './BeforeAfterSlider';
import RecentWorkGallery from './RecentWorkGallery';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function imageUrl(path) {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  return `${API}/files/${path}`;
}

const Gallery = () => {
  const [galleryItems, setGalleryItems] = useState(null);
  const [recentItems, setRecentItems] = useState(null);

  useEffect(() => {
    fetch(`${API}/content/gallery`).then(r => r.json()).then(data => {
      if (data.length > 0) setGalleryItems(data);
    }).catch(() => {});
    fetch(`${API}/content/recent-work`).then(r => r.json()).then(data => {
      if (data.length > 0) setRecentItems(data);
    }).catch(() => {});
  }, []);

  const gallery = galleryItems
    ? galleryItems.map(item => ({
        id: item.id,
        before: imageUrl(item.before_image_path),
        after: imageUrl(item.after_image_path),
        title: item.title,
        description: item.description,
      }))
    : defaultGallery;

  const recentWork = recentItems
    ? recentItems.map(item => ({
        id: item.id,
        url: imageUrl(item.image_path),
        title: item.title,
        description: item.description,
      }))
    : defaultRecentWork;

  return (
    <section id="gallery" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">Gallery</h2>
          <p className="text-xl text-gray-600">See the transformative results we deliver for our clients</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {gallery.map((image) => (
            <BeforeAfterSlider
              key={image.id}
              beforeImage={image.before}
              afterImage={image.after}
              title={image.title}
              description={image.description}
            />
          ))}
        </div>

        <RecentWorkGallery images={recentWork} />
      </div>
    </section>
  );
};

export default Gallery;
